/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const createTemplate = /* GraphQL */ `mutation CreateTemplate(
  $input: CreateTemplateInput!
  $condition: ModelTemplateConditionInput
) {
  createTemplate(input: $input, condition: $condition) {
    id
    name
    input
    textLayers {
      name
      font
      defaultText
      __typename
    }
    textLayerName
    textLayerFont
    otherFonts
    poster
    attribution
    hidden
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTemplateMutationVariables,
  APITypes.CreateTemplateMutation
>;
export const updateTemplate = /* GraphQL */ `mutation UpdateTemplate(
  $input: UpdateTemplateInput!
  $condition: ModelTemplateConditionInput
) {
  updateTemplate(input: $input, condition: $condition) {
    id
    name
    input
    textLayers {
      name
      font
      defaultText
      __typename
    }
    textLayerName
    textLayerFont
    otherFonts
    poster
    attribution
    hidden
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTemplateMutationVariables,
  APITypes.UpdateTemplateMutation
>;
export const deleteTemplate = /* GraphQL */ `mutation DeleteTemplate(
  $input: DeleteTemplateInput!
  $condition: ModelTemplateConditionInput
) {
  deleteTemplate(input: $input, condition: $condition) {
    id
    name
    input
    textLayers {
      name
      font
      defaultText
      __typename
    }
    textLayerName
    textLayerFont
    otherFonts
    poster
    attribution
    hidden
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTemplateMutationVariables,
  APITypes.DeleteTemplateMutation
>;
export const createCampaign = /* GraphQL */ `mutation CreateCampaign(
  $input: CreateCampaignInput!
  $condition: ModelCampaignConditionInput
) {
  createCampaign(input: $input, condition: $condition) {
    id
    userId
    templateId
    template {
      id
      name
      input
      textLayers {
        name
        font
        defaultText
        __typename
      }
      textLayerName
      textLayerFont
      otherFonts
      poster
      attribution
      hidden
      createdAt
      updatedAt
      __typename
    }
    name
    width
    customText {
      layerName
      text
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCampaignMutationVariables,
  APITypes.CreateCampaignMutation
>;
export const updateCampaign = /* GraphQL */ `mutation UpdateCampaign(
  $input: UpdateCampaignInput!
  $condition: ModelCampaignConditionInput
) {
  updateCampaign(input: $input, condition: $condition) {
    id
    userId
    templateId
    template {
      id
      name
      input
      textLayers {
        name
        font
        defaultText
        __typename
      }
      textLayerName
      textLayerFont
      otherFonts
      poster
      attribution
      hidden
      createdAt
      updatedAt
      __typename
    }
    name
    width
    customText {
      layerName
      text
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCampaignMutationVariables,
  APITypes.UpdateCampaignMutation
>;
export const deleteCampaign = /* GraphQL */ `mutation DeleteCampaign(
  $input: DeleteCampaignInput!
  $condition: ModelCampaignConditionInput
) {
  deleteCampaign(input: $input, condition: $condition) {
    id
    userId
    templateId
    template {
      id
      name
      input
      textLayers {
        name
        font
        defaultText
        __typename
      }
      textLayerName
      textLayerFont
      otherFonts
      poster
      attribution
      hidden
      createdAt
      updatedAt
      __typename
    }
    name
    width
    customText {
      layerName
      text
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCampaignMutationVariables,
  APITypes.DeleteCampaignMutation
>;
export const createTracking = /* GraphQL */ `mutation CreateTracking(
  $input: CreateTrackingInput!
  $condition: ModelTrackingConditionInput
) {
  createTracking(input: $input, condition: $condition) {
    id
    userId
    templateId
    templateData
    campaignData
    text
    width
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTrackingMutationVariables,
  APITypes.CreateTrackingMutation
>;
export const updateTracking = /* GraphQL */ `mutation UpdateTracking(
  $input: UpdateTrackingInput!
  $condition: ModelTrackingConditionInput
) {
  updateTracking(input: $input, condition: $condition) {
    id
    userId
    templateId
    templateData
    campaignData
    text
    width
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTrackingMutationVariables,
  APITypes.UpdateTrackingMutation
>;
export const deleteTracking = /* GraphQL */ `mutation DeleteTracking(
  $input: DeleteTrackingInput!
  $condition: ModelTrackingConditionInput
) {
  deleteTracking(input: $input, condition: $condition) {
    id
    userId
    templateId
    templateData
    campaignData
    text
    width
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTrackingMutationVariables,
  APITypes.DeleteTrackingMutation
>;
